import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./landing.css";

const LINKS = [
  { title: "About", id: "aboutus" },
  { title: "Quality", id: "qualityassured" },
  { title: "Ordering", id: "ordering" },
  { title: "Delivery", id: "delivery" },
  { title: "Contact", id: "contactus" },
];

const Footer2 = () => {
  const history = useHistory();
  const location = useLocation();
  const onLanding = location.pathname === "/" || location.pathname === "/home";

  const go = (e, id) => {
    e.preventDefault();
    if (!onLanding) {
      history.push(`/home#${id}`);
      return;
    }
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="tfm-footer" id="footer-id">
      <div className="tfm-container">
        <div className="tfm-footer__top">
          <a className="tfm-footer__brand" href="/home">
            <img src="/images/icon-sm.png" alt="" aria-hidden="true" />
            <span className="tfm-footer__name">
              Tripoli Fresh Market
              <br />
              Wholesale
            </span>
          </a>

          <nav className="tfm-footer__links" aria-label="Footer">
            {LINKS.map((link) => (
              <a
                key={link.id}
                href={`/home#${link.id}`}
                onClick={(e) => go(e, link.id)}
              >
                {link.title}
              </a>
            ))}
            <a href="/privacypolicy">Privacy policy</a>
            <a href="/login">Login</a>
          </nav>

          <div className="tfm-footer__stores">
            <a href="/" aria-label="Get it on Google Play">
              <img src="/images/gglplay.png" alt="Get it on Google Play" loading="lazy" />
            </a>
            <a href="/" aria-label="Download on the App Store">
              <img src="/images/appstore.png" alt="Download on the App Store" loading="lazy" />
            </a>
          </div>
        </div>

        <div className="tfm-footer__bottom">
          <p>&copy; 2024 Tripoli Fresh Market. All rights reserved.</p>
          <p>Developed by Arco Energies LLC.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
